import Application from "views/Receiver/Application.jsx";
import Locations from "views/Receiver/Locations.jsx";
import Calendar from "views/Receiver/Calendar.jsx";
import ReceiverShipments from "views/Receiver/ReceiverShipments.jsx";
import Account from "views/Receiver/Account.jsx";

// @material-ui/icons
import PersonAdd from "@material-ui/icons/PersonAdd";


const receiverRoutes = [
  {
    path: "/receiver/locations",
    name: "Locations",
    short: "Locations",
    mini: "LO",
    icon: PersonAdd,
    component: Locations
  },
  {
    path: "/receiver/application",
    name: "Application",
    short: "Application",
    mini: "AP",
    icon: PersonAdd,
    component: Application
  },
  {
    path: "/receiver/shipments",
    name: "Shipments",
    short: "Shipments",
    mini: "SH",
    icon: PersonAdd,
    component: ReceiverShipments
  },
    {
    path: "/receiver/calendar",
    name: "Calendar",
    short: "Calendar",
    mini: "CA",
    icon: PersonAdd,
    component: Calendar
  },
    {
    path: "/receiver/account",
    name: "Account",
    short: "Account",
    mini: "AC",
    icon: PersonAdd,
    component: Account
  },
];


export default receiverRoutes;



// WEBPACK FOOTER //
// ./src/routes/receiver.jsx